import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Box, Typography } from "@mui/material";
import { useBrandRatingRubric } from "./hooks/useBrandRatingRubric";
import CreateRubricForm from "./CreateRubricForm";

export default function BrandRatingRubricsPage() {
  const { rubrics, loading, error, fetchRubrics } = useBrandRatingRubric();
  const [showCreateForm, setShowCreateForm] = useState(false);

  React.useEffect(() => {
    fetchRubrics();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <p>Loading rubrics…</p>;
  }

  if (error) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="error">
          {error?.message || error?.error || "Error loading rubrics"}
        </Typography>
      </Box>
    );
  }

  const handleCreateSuccess = (newRubric) => {
    setShowCreateForm(false);
    fetchRubrics();
  };

  return (
    <Box sx={{ p: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3
        }}
      >
        <Typography variant="h4" component="h1" sx={{ fontWeight: "bold" }}>
          Brand Rating Rubrics
        </Typography>
        {!showCreateForm && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => setShowCreateForm(true)}
            sx={{
              px: 3,
              py: 1.5,
              fontWeight: 600,
              boxShadow: 2,
              "&:hover": {
                boxShadow: 4,
                transform: "translateY(-1px)"
              },
              transition: "all 0.2s ease"
            }}
          >
            + Create New Rubric
          </Button>
        )}
      </Box>

      {showCreateForm && (
        <Box sx={{ maxWidth: 600, mb: 3 }}>
          <CreateRubricForm
            onSuccess={handleCreateSuccess}
            onCancel={() => setShowCreateForm(false)}
          />
        </Box>
      )}

      {(!rubrics || rubrics.length === 0)
        ? (
          <Typography>No rubrics found.</Typography>
        )
        : (
          <Box component="ul" sx={{ listStyle: "none", p: 0, m: 0 }}>
            {rubrics.map((rb) => (
              <Box
                component="li"
                key={rb.id}
                sx={{
                  border: 1,
                  borderColor: "grey.300",
                  borderRadius: 1,
                  p: 2,
                  mb: 1,
                  "&:hover": {
                    backgroundColor: "grey.50"
                  },
                  transition: "background-color 0.2s"
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Link
                    to={`/brand-rating-rubrics/${rb.id}`}
                    style={{ textDecoration: "none", fontWeight: 500 }}
                  >
                    {rb.category ?? `Rubric #${rb.id}`}
                  </Link>
                  <Typography variant="body2" color="text.secondary">
                    Last updated: {new Date(rb.updatedAt).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit"
                    })}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        )}
    </Box>
  );
}
